import React, { useState } from 'react';
import './Portfolio.css'
import Card from './Card'
import {fullStackApps, landingPages} from './Projects-data'
import { Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { IoIosApps } from "react-icons/io";
import { RiPagesFill } from "react-icons/ri";
import Typography from '@mui/material/Typography'

export default function Portfolio ({ onClick }) {
    const [value, setValue] = useState('1')
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const handleClick = () => {
        onClick('4')
    }


  return (

    <div className="project-container">
        <div className="row project-parent">
            <div className="project-details">
            <span className="primary-headline">
                <h1><span className="underline">Projects</span> I built</h1>
            </span>
                <span classname="project-text">
                    <p>I am excited to share some of my previous work with you and showcase my skills as a full stack developer.<br/>
                    Whether you are a recruiter or a potential customer, I am confident that my portfolio will give you a good sense of my abilities and what I can offer to achieve seamless and user-friendly web experiences.
                    <br/>
                    </p>
            
                </span>
                <div className="project-details">
                        <TabContext value={value}>
                        <Box>
                            <TabList 
                                aria-label='Tabs example' 
                                onChange={handleChange}
                                centered
                                TabIndicatorProps={{sx: {backgroundColor: 'transparent'}}}
                                sx={{
                                    "& button": { color: 'aliceblue', fontSize: "12px"},
                                    "& button.Mui-selected": { color: "#00FFCA", fontSize:"14px", backgroundColor:"#0A4D68", borderRadius: `${value === '1' ? "40px 10px" : "10px 40px"}`, width:"15rem"},
                                    '& .MuiTabs-flexContainer': { flexWrap: 'wrap',},

                                }}
                                >
                                <Tab icon={<IoIosApps size="2em"/>} iconPosition="start" label='Web Apps' value='1'/>
                                <Tab icon={<RiPagesFill size="2em"/>} iconPosition="start" label='Landing Pages' value='2' />

                            </TabList>
                        
                        </Box>

                        <TabPanel className={`d-flex flex-wrap ${value === '1' ? 'd-block' : 'd-none'}`} value='1'>
                            {/*<span className="primary-headline pb-5">
                            <h1><IoIosApps/> <span className="underline">Web Apps</span></h1>
                            </span>*/}
                            <div className="row justify-content-around align-items-stretch">

                            {fullStackApps.map((project, i) =>(

                                <Card key= {i} className="col-md-6 col-12  p-3 align-self-stretch project-card" type="web-app" carouselId={`carousel${i}`} img1={project.img1} img2={project.img2} title={project.title} desc={project.desc} frameworks={project.frameworks}/>
                                    
                            ))}

                            </div>
                        </TabPanel>
                        <TabPanel className={`d-flex flex-wrap ${value === '2' ? 'd-block' : 'd-none'}`} value='2'>
                            {/*<span className="primary-headline">
                            <h1><RiPagesFill /> <span className="underline">Landing Pages</span></h1>
                            </span>*/}
                            <Typography>
                                <p>These landing pages are focusing on driving and converting warm leads for businesses through <b style={{color: "cornsilk"}}>Facebook Ads</b> and <b style={{color: "cornsilk"}}>Google Ads</b> compaigns.<br/>
                                My approach was to create a design and content that convey the client's value proposition and ensure excellent user experience. Also, I always make sure to meet best practices for responsiveness and page load speed to optimize performance. <br/> 
                                
                                <span style={{color: "cornsilk"}}>Tools:</span> <p style={{fontSize: "14px"}}><em>Elementor, Contact Form 7, Google Sheets</em> and other useful WordPress plugins.</p>
                                
                                
                                </p>
                            </Typography>
                            <div className="row justify-content-around align-items-stretch">
                            {landingPages.map((project, i) =>(

                                <Card key= {i} className="col-md-4 col-12  p-3 align-self-stretch project-card" type="landing-page" carouselId={`carousel${i}`} img1={project.img1} img2={project.img2} img3={project.img3} title={project.title} desc={project.desc}/>
                                    
                            ))}
                            </div>
                        </TabPanel>

                    </TabContext>

                </div>

                <div className="project-options d-flex justify-content-center">
                    <button className="btn primary-btn" onClick ={handleClick}>
                    Hire Me{" "}
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}